import type { SvgProps } from '@/types/svgs/svg-types';
import { SwjIconRadioBase } from './swj-icon-radio-base';

const checkmarkPath =
    'M14.5594 17.4381L16.4292 19.3033L22.3729 12.5121C22.9185 11.8887 23.8662 11.8257 24.4896 12.3713C25.113 12.9169 25.176 13.8645 24.6304 14.4879L17.6321 22.484C17.3589 22.7962 16.9687 22.9812 16.5541 22.9953C16.1395 23.0093 15.7377 22.851 15.444 22.5581L12.4406 19.562C11.8541 18.9769 11.853 18.0271 12.4381 17.4406C13.0231 16.8541 13.9729 16.853 14.5594 17.4381Z';

export const SiteWideJackpotCheckmark = ({ width, height }: SvgProps) => (
    <SwjIconRadioBase width={width} height={height} testId="site-wide-jackpot-checkmark">
        <path fillRule="evenodd" clipRule="evenodd" d={checkmarkPath} fill="white" />
        <g filter="url(#filter1_ii_8601_70075)">
            <path fillRule="evenodd" clipRule="evenodd" d={checkmarkPath} fill="white" />
        </g>
    </SwjIconRadioBase>
);

export default SiteWideJackpotCheckmark;
